export const getIsFetching = state => state.userOdt.isFetching;
export const getErrorMessage = state => state.userOdt.errorMessage;
export const getIsResending = (state) => state.userOdt.isResending;

